import React, { useState, useEffect } from "react";
import { useOrder } from "../context/OrderContext";
import { useStepNavigate } from "../hooks/useStepNavigate";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { loadModelImage } from "../utils/modelImage";

const ValasztottModell = () => {
	const { order } = useOrder();
	const navigate = useStepNavigate();
	const [imageSrc, setImageSrc] = useState(null);
    const [imageLoading, setImageLoading] = useState(true);


	const modelName = order?.hmeliorder?.hmeliorder_modell_num || "";
	const modelId = order?.hmeliorder?.hmeliorder_model_id || "";

	const handleAnswerYes = () => {
		navigate("/RogzitesTipus");
	};

	const handleAnswerNo = () => {
		navigate("/ModellValaszto");
	};

	useEffect(() => {
        const loadImage = async () => {
            setImageLoading(true);
            const src = await loadModelImage(modelName);
            setImageSrc(src);
            setImageLoading(false);
        };

        loadImage();
    }, [modelName]);



	return (
		<TablerLayout title="Választott modell">
			<div className="row justify-content-center">
				<div className="col-md-10">
					<div className="card text-center">
						<div className="card-header">
							<h3 className="card-title">
								{modelName ? (
									<>
										Kiválasztott modell: <b>{modelName}</b> 
                                        {modelId && <span> (szám: {modelId})</span>}
									</>
								) : (
									"Nincs kiválasztott modell"
								)}
							</h3>
						</div>
						<div className="card-body">
                            {imageLoading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Kép betöltése...</span>
                                    </div>
                                </div>
                            ) : (
                                <img 
                                    src={imageSrc} 
                                    alt={modelName ? `${modelName} modell` : "Modell helyőrző"} 
                                    style={{ 
                                        maxWidth: "300px", 
                                        maxHeight: "300px",
                                        objectFit: "contain" // Képarány megőrzése
                                    }} 
                                    onError={(e) => {
                                        e.target.src = require("../components/images/model_placeholder.png");
                                    }}
                                />
                            )}
                        </div>
						<div className="card-footer d-flex justify-content-between">
							<StepperNavButton side="left" label="Vissza" onClick={handleAnswerNo} />
							<StepperNavButton side="right" label="Tovább" onClick={handleAnswerYes} />
						</div>
					</div>
				</div>
			</div>
		</TablerLayout>
	);
};

export default ValasztottModell;
